module.exports = __webpack_public_path__ + "media/images/flags/4x3/sun-dfd9cf986b2b1419b7fd303c8ab74426.svg";